var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBusiness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D83E2DA5-FB40-41FF-8956-B95EF9311CDF@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SignLive-App-Style-Guide",
    transform: "translate(-321.000000, -4594.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatars/Circle/Icon",
    transform: "translate(321.000000, 4594.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u21B3Select-Color",
    fill: "#646B74",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "1.-Icon/User",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2497487,22.1875 L31.2497487,27.5322549 C31.2497487,28.7034591 30.2773978,29.6623929 29.0898064,29.6623929 L29.0898064,29.6623929 L10.9099424,29.6623929 C9.72235095,29.6623929 8.75,28.7034591 8.75,27.5322549 L8.75,27.5322549 L8.75,22.4377644 C9.17823792,23.510437 11.4291996,23.8683185 13.9174465,23.9071383 L13.9174465,23.9071383 L27.1375669,23.9145719 C28.7037135,23.9145719 30.9154892,23.4953308 31.2497487,22.1875 L31.2497487,22.1875 Z M24.0206,10 C25.2081914,10 26.1805424,10.9581078 26.1805424,12.130138 L26.1805424,12.130138 L26.1805424,13.8539061 L29.0900576,13.8539061 C30.277649,13.8539061 31.25,14.8120139 31.25,15.9832181 L31.25,15.9832181 L31.25,19.3897629 C31.25,21.2446213 28.7935785,22.1555799 27.1378181,22.1555799 L27.1378181,22.1555799 L26.1587671,22.1555799 L13.9176977,22.1506242 C10.9034935,22.099415 8.75025125,21.2748337 8.75025125,19.3897629 L8.75025125,19.3897629 L8.75025125,15.9832181 C8.75025125,14.8120139 9.72176469,13.8539061 10.9101936,13.8539061 L10.9101936,13.8539061 L13.8197089,13.8539061 L13.8197089,12.130138 C13.8197089,10.9581078 14.7912223,10 15.9796513,10 L15.9796513,10 Z M23.372366,11.5635328 L16.6278852,11.5635328 C16.0407896,11.5635328 15.560058,12.037631 15.560058,12.6166255 L15.560058,12.6166255 L15.560058,13.8539061 L24.4401933,13.8539061 L24.4401933,12.6166255 C24.4401933,12.037631 23.9594616,11.5635328 23.372366,11.5635328 L23.372366,11.5635328 Z",
    id: "Icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon_business.7a083f69d4a88a07240d14f917300ea9.svg";
export { ForwardRef as ReactComponent };